module.exports = __webpack_public_path__ + "media/images/hero/hero2-person-background-237562e151fdb3c2a21dbee5645bd345.png";